headerContainer.$inject = ["API_URL", "$rootScope", "$timeout"];
angular.module('calendarApp').directive('headerContainer', headerContainer);

function headerContainer(API_URL, $rootScope, $timeout) {
  return {
    restrict: 'EA',
    replace: true,
    template: "<div class=\"header-container\">\n\n                        <logo-container></logo-container>\n                        <customer-account-button></customer-account-button>\n                \n                    </div>",
    link: function link(scope, elem, attrs) {}
  };
}